var _defs, _polyline, _path, _circle, _circle2, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKursRegularny(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Warstwa 1",
    viewBox: "0 0 200 268",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:none;}.cls-1,.cls-2{stroke:#000;}.cls-1,.cls-2,.cls-3{stroke-miterlimit:10;}.cls-2{fill:#ac893a;}.cls-3{stroke:#ac893a;stroke-width:2.92px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "menu_grafika_regularny") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    transform: "translate(23.36)",
    points: "59.57 0 59.57 146.3 93.56 146.3 93.56 0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m100 115.37a76.14 76.14 0 1 0 76.14 76.14 76.1 76.1 0 0 0-76.14-76.14zm0 116a39.82 39.82 0 1 1 39.82-39.82 39.78 39.78 0 0 1-39.82 39.78z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 100,
    cy: 191.51,
    r: 39.82
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 100,
    cy: 190.86,
    r: 39.82
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m175.26 136.31a16.93 16.93 0 0 1-16.92 16.77 16.51 16.51 0 0 1-12.11-5 16 16 0 0 1-5-12 16.51 16.51 0 0 1 5-12.11 16 16 0 0 1 12-5 16.94 16.94 0 0 1 17.07 17.21z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m175.26 214.19a16.93 16.93 0 0 1-16.92 16.77 16.51 16.51 0 0 1-12.11-5 16 16 0 0 1-5-12 16.51 16.51 0 0 1 5-12.11 16 16 0 0 1 12-5 16.94 16.94 0 0 1 17.07 17.21z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m175.26 58.56a16.93 16.93 0 0 1-16.92 16.77 16.51 16.51 0 0 1-12.11-5 16 16 0 0 1-5-12 16.51 16.51 0 0 1 5-12.11 16 16 0 0 1 12-5 16.94 16.94 0 0 1 17.07 17.21z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKursRegularny);
export default __webpack_public_path__ + "static/media/kurs_regularny.8be36e9a10764d0a0f9b42f8ea1ecac9.svg";
export { ForwardRef as ReactComponent };